import React from 'react';
import Radio from '@material-ui/core/Radio';

class AbacusRadioButton extends React.Component {
  handleChange = event => {
    if(this.props.onChange !== undefined){
      this.props.onChange(event);
    }
  };

  labelStyle ={
    cursor: "pointer"
  }

  divFloatStyle ={
    float:"left",
    height:"40px",
    lineHeight: "40px",
  }
  
    render() {
      return (
        <span>
          <div style={{float:"left"}}>
            <Radio
              disabled={this.props.disabled}
              checked={this.props.checked}
              onChange={this.handleChange}
              value={this.props.value}
              name={this.props.name}
              id={this.props.id}
            />
          </div>
          <div style={this.divFloatStyle}>
            <label onClick={this.handleChange} style={this.labelStyle} htmlFor={this.props.id}>{this.props.label}</label>
          </div>
        </span>
      );
    }
  }

  export default AbacusRadioButton;